import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-wrapper">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-col">
              <div className="footer-brand">
                <span className="footer-logo-text">DFW Health Tech</span>
                <p className="footer-description section-content">
                  {' '}
                  The premier intelligence hub for the Dallas-Fort Worth health
                  technology ecosystem. Aggregating data, news, and funding for
                  innovators and investors.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="footer-social-group">
                <a href="#">
                  <div aria-label="LinkedIn" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                      <circle cx="4" cy="4" r="2"></circle>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"></path>
                    </svg>
                  </div>
                </a>
                <a href="mailto:contact@dfwhealthtech.com?subject=">
                  <div aria-label="Email" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                      <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-col">
              <h2 className="footer-heading section-subtitle">Ecosystem</h2>
              <nav className="footer-nav">
                <ul className="footer-list">
                  <li className="footer-item">
                    <a href="/homepage">
                      <div className="footer-link">
                        <span>Directory</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-item">
                    <a href="#">
                      <div className="footer-link">
                        <span>Investors</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-item">
                    <a href="#">
                      <div className="footer-link">
                        <span>Accelerators</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-item">
                    <a href="/news-insights">
                      <div className="footer-link">
                        <span>News &amp; Insights</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-item">
                    <a href="#">
                      <div className="footer-link">
                        <span>Funding Activity</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="footer-col">
              <h2 className="footer-heading section-subtitle">
                Intelligence Brief
              </h2>
              <p className="footer-subtext section-content">
                {' '}
                Join 2,500+ professionals receiving our weekly analysis of
                DFW&apos;s health tech market.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <form
                action="/newsletter-signup"
                method="POST"
                data-form-id="9627b685-e90b-4d57-9e40-af38e0b58324"
                className="footer-form"
              >
                <div className="footer-input-group">
                  <label
                    htmlFor="footer-email"
                    className="footer-visually-hidden"
                  >
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="footer-email"
                    name="email"
                    placeholder="Work email address"
                    required="true"
                    data-form-field-id="footer-email"
                    className="footer-input"
                  />
                  <button
                    type="submit"
                    id="thq_button_r2vE"
                    name="button"
                    data-form-field-id="thq_button_r2vE"
                    className="footer-submit-btn btn btn-primary"
                  >
                    <span>Subscribe</span>
                  </button>
                </div>
                <p className="footer-form-notice">
                  By subscribing, you agree to our privacy policy.
                </p>
              </form>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p className="footer-copyright">
                &amp;copy; 2026 DFW Health Tech. All rights reserved.
              </p>
              <div className="footer-legal-links">
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Terms of Service</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Sitemap</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-newsletter">
(function(){
const footerForm = document.querySelector('.footer-form');
if (footerForm) {
  footerForm.addEventListener('submit', (e) => {
    const emailInput = document.getElementById('footer-email');
    if (emailInput && emailInput.checkValidity()) {
      const submitBtn = footerForm.querySelector('.footer-submit-btn');
      const originalText = submitBtn.innerHTML;
      
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span>Processing...</span>';
      
      setTimeout(() => {
        submitBtn.style.backgroundColor = '#2ecc71';
        submitBtn.innerHTML = '<span>Success!</span>';
        emailInput.value = '';
        
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
          submitBtn.style.backgroundColor = '';
        }, 3000);
      }, 1000);
    }
  });
}
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
